module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Bold.woff?e995066dadb195d3b48feb99d342a77f";